import { z } from 'zod'
import { Language, UserStatus } from '../types/users.types'

export const userSchema = z.object({
  id: z.uuid(),
  cognitoSub: z.string().optional(),
  status: z.enum(UserStatus),
  email: z.email(),
  phone: z.string().optional(),
  name: z.string().optional(),
  lastName: z.string().optional(),
  language: z.enum(Language),
  timezone: z.string().optional(),
  avatarUri: z.string().optional().nullable(),
  did: z.string().optional(),
  didPrivateKeyHex: z.string().optional(),
  registeredAt: z.date().optional(),
  createdAt: z.iso.datetime(),
  updatedAt: z.iso.datetime(),
  lastLoginAt: z.iso.datetime().optional()
})
